import { render, staticRenderFns } from "./relation-template.vue?vue&type=template&id=3faf107b&scoped=true&"
import script from "./relation-template.vue?vue&type=script&lang=js&"
export * from "./relation-template.vue?vue&type=script&lang=js&"
import style0 from "./relation-template.vue?vue&type=style&index=0&id=3faf107b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faf107b",
  null
  
)

export default component.exports